// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDuQepWt0M-u5-5cF8-6zVVAoXVK6cUVJM",
  authDomain: "porfolio-201e9.firebaseapp.com",
  projectId: "porfolio-201e9",
  storageBucket: "porfolio-201e9.firebasestorage.app",
  messagingSenderId: "892929758543",
  appId: "1:892929758543:web:efd97fffcfa3eebf3a613a",
  measurementId: "G-XGN8Z7WN5Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { db, auth,analytics };